import { WorkflowQuestionType } from 'libs/shared-logic/src/routine/domain/workflow/workflowQuestionType';
import { useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Platform, StyleSheet, View } from 'react-native';
import { Button } from 'react-native-paper';
import { Select } from '../../../forms';

export const AddQuestion = ({
  i18nPrefix,
  onPress,
}: {
  i18nPrefix: string;
  onPress: (type: WorkflowQuestionType) => void;
}) => {
  const { t } = useTranslation();
  const [showQuestionTypes, setShowQuestionTypes] = useState(false);
  const questionTypeRef = useRef(null);

  const questionTypes = useMemo(() => {
    const types = [];
    const typePrefix = 'routines.workflow.questionTypes';

    for (const type in WorkflowQuestionType) {
      const value =
        WorkflowQuestionType[type as keyof typeof WorkflowQuestionType];
      const label = t(`${typePrefix}.${value}`);
      types.push({ label, value });
    }

    return types;
  }, []);

  const onTypeSelected = (type: WorkflowQuestionType) => {
    setShowQuestionTypes(false);
    onPress(type);
  };

  const handleDropdownOpen = () => {
    if (Platform.OS !== 'web') return;

    setTimeout(() => {
      if (questionTypeRef.current) {
        const element = questionTypeRef.current as unknown as HTMLElement;

        if (element && typeof element.scrollIntoView === 'function') {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
          });
        }
      }
    }, 150);
  };

  return (
    <View style={styles.addQuestion}>
      {showQuestionTypes ? (
        <View ref={questionTypeRef} style={styles.questionType}>
          <Select
            items={questionTypes}
            onSelectItem={(item) => onTypeSelected(item)}
            label={t(`${i18nPrefix}.questionType`)}
            listMode="SCROLLVIEW"
            dropDownContainerStyle={{ maxHeight: 500 }}
            dropDownPickerProps={{
              dropDownDirection: 'TOP',
              onOpen: handleDropdownOpen,
            }}
          />
        </View>
      ) : (
        <Button icon="plus" onPress={() => setShowQuestionTypes(true)}>
          {t(`${i18nPrefix}.addQuestion`)}
        </Button>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  addQuestion: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    position: 'relative',
  },
  questionType: {
    maxWidth: 550,
  },
});
